module.exports = __webpack_public_path__ + "img/Customer-Visits-Visiting-Customer3@2x.4b110a42.jpg";